export const accountPageActions = {
    MOVE_TO_ONBOARDING: "onboarding",
    MOVE_TO_REHIRE: "rehire",
    MOVE_TO_REJECTED: "reject",
}
